import {React, useState} from 'react'
import { Link } from 'react-router-dom';

function Header() {
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const username=localStorage.getItem("userName")
	// Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
      };

  return (
    <>
    
      <div className="navbar-header">
            <nav className="navbar navbar-expand navbar-light navbar-bg">
                {/* <button onClick={toggleSidebar}  id='toggle-button' className="sidebar-toggle js-sidebar-toggle">
                    <i className="hamburger align-self-center"></i>
                </button> */}
                <h4 className="header_title">Lucknow Swachhata Abhiyan</h4>
                
                <div className="navbar-collapse collapse">
                    <ul className="navbar-nav navbar-align">
                        <li className="nav-item pt-2 admin_info">Welcome <br></br> <p className='mb-0'>{username.toUpperCase()}</p></li> 
                        <li className="nav-item dropdown">
                            <Link className="nav-icon pe-md-0 dropdown-toggle" to="/" data-bs-toggle="dropdown">
                                {/* <img src="img/avatars/avatar.jpg" className="avatar img-fluid rounded" alt="Charles Hall" /> */}
                              
                            </Link>
                            
                            <div className="dropdown-menu dropdown-menu-end">
                                {/* <Link className="dropdown-item" to="/">Log out</Link> */}
                                
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </>
  )
}

export default Header
